import OwnerUpdaterModel from './owner-updater-model'
import OwnerUpdaterStep2 from './owner-updater-step2'
import ReportFilterUtil from '../common/report-filter-util'
import AncestorStep from '../common/ancestor-step'
import _ from 'lodash'

export default {
	icon: 'profile',
	key: 'report.ownerUpdaterReport.title',
	steps: [AncestorStep, {
		titleCode: 'report.ownerUpdaterReport.title',
		view: OwnerUpdaterStep2,
		validate: function(attrs, opts) {
			let owners = _.result(attrs.filters,'owners[0]', {})
			let updaters =_.result(attrs.filters,'updaters[0]', {})
			let hasOwners = ReportFilterUtil.hasValues(attrs, 'owners') || owners.anyValue === true
			let hasUpdaters = ReportFilterUtil.hasValues(attrs, 'updaters') || updaters.anyValue === true

			//must have either an org, or owner/updater selected
			return !ReportFilterUtil.hasAncestorValues(attrs, 'scorecardNodeIds') ||
				(!hasOwners && !hasUpdaters)
		}
	}],
	model: OwnerUpdaterModel
}
